<div
    class="inline-block relative"
    (click)="umami.track('open-language-selection')"
>
    <label for="hs-footer-language-dropdown" class="sr-only"> Language </label>
    <select
        aria-orientation="vertical"
        aria-labelledby="hs-footer-language-dropdown"
        [ngModel]="selectedLanguage()"
        id="hs-footer-language-dropdown"
        name="hs-footer-language-dropdown"
        (ngModelChange)="changeLanguage($event)"
        class="items-center gap-x-2 bg-primary-darker hover:bg-primary focus:bg-primary disabled:opacity-50 shadow-sm py-2 pr-3 pl-8 border border-neutral-700 rounded-lg focus:outline-none text-[#fff] text-sm hover:scale-105 transition-[transform,colors] appearance-none cursor-pointer disabled:pointer-events-none"
    >
        <option value="en">{{ isMinimal() ? "" : "English" }} (EN)</option>
        <option value="de">{{ isMinimal() ? "" : "Deutsch" }} (AT)</option>
    </select>
    <div
        class="left-0 absolute inset-y-0 flex items-center pl-2 pointer-events-none"
    >
        <span
            class="icon-flag"
            [ngClass]="{
                'english-flag': selectedLanguage() === 'en',
                'german-flag': selectedLanguage() === 'de',
            }"
        ></span>
    </div>
</div>
